import AddOnApi from 'client/api/v2/AddOnApi';
import CollectionModule from 'client/store/modules/CollectionModule';
import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const { SubscriptionFields } = SubscriptionConstants;
const { listPrice, productCode } = SubscriptionFields;

export class AddOnCollectionClass extends CollectionModule { }

export default new AddOnCollectionClass(AddOnApi, productCode, listPrice).extractModule();
